import axios from "axios";

export const serverUrl = "https://api.riplestack.com";

export const axiosApi = axios.create({
  baseURL: serverUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add response interceptor for handling auth errors
axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear local storage
      localStorage.removeItem("Riplestack_info");
      // Redirect to login
      window.location.href = "/auth/sign-in";
    }
    return Promise.reject(error);
  }
);
